module.exports = __webpack_public_path__ + "img/gear-candles.3a9658b9.svg";